import React from "react";
import { Form, Input, Select } from "antd";
import PropTypes from "prop-types";

import FormLabel from "components/FormLabel/FormLabel";
import { formatCountdown } from "antd/lib/statistic/utils";

const FormItem = Form.Item;
const InputGroup = Input.Group;

const { Option } = Select;

const FormGroupSelectionInput = ({
  disabled,
  extraProps,
  inputDefaultValue,
  inputPlaceholder,
  inputName,
  inputType,
  label,
  name,
  onFocus,
  selectionName,
  selections,
  selectionPlaceholder,
  selectionDefaultValue,
  requiredErrorMessage,
  shouldUpdateField,
}) => {
  const generatePropsForRules = () => {
    const rules = [];
    if (requiredErrorMessage && typeof requiredErrorMessage === "string") {
      rules.push({
        required: true,
        message: requiredErrorMessage,
      });
    }
    return rules;
  };

  const ContactNumberUpdate = (
    <FormItem noStyle shouldUpdate>
      {({ getFieldValue, setFieldsValue }) => {
        // console.log("getFieldValue", getFieldValue("country"));

        setTimeout(() => {
          setFieldsValue({
            contact: {
              countryCode:
                getFieldValue("country") === "Malaysia"
                  ? "+60"
                  : getFieldValue("country") === "Singapore"
                  ? "+65"
                  : getFieldValue("country") === "Indonesia"
                  ? "+62"
                  : "+60",
            },
          });
        }, 100);

        return (
          <InputGroup compact>
            <FormItem
              name={selectionName}
              onFocus={() => onFocus(name)}
              style={{ width: "40%" }}
            >
              <Select
                placeholder={selectionPlaceholder}
                style={{ width: "100%" }}
                defaultValue={selectionDefaultValue}
              >
                {selections.map((selection) => (
                  <Option key={selection.value} value={selection.value}>
                    {selection.label || selection.value}
                  </Option>
                ))}
              </Select>
            </FormItem>

            <FormItem
              rules={generatePropsForRules()}
              name={inputName}
              onFocus={() => onFocus(name)}
              style={{ width: "60%" }}
            >
              <Input
                style={{ width: "100%" }}
                placeholder={inputPlaceholder}
                defaultValue={inputDefaultValue}
                type={inputType}
                {...extraProps}
              />
            </FormItem>
          </InputGroup>
        );
      }}
    </FormItem>
  );

  return (
    <>
      {label && <FormLabel>{label}</FormLabel>}
      {shouldUpdateField === "contactNumberUpdate" ? (
        ContactNumberUpdate
      ) : (
        <InputGroup compact>
          <FormItem
            name={selectionName}
            onFocus={() => onFocus(name)}
            style={{ width: "40%" }}
          >
            <Select
              placeholder={selectionPlaceholder}
              style={{ width: "100%" }}
              defaultValue={selectionDefaultValue}
            >
              {selections.map((selection) => (
                <Option key={selection.value} value={selection.value}>
                  {selection.label || selection.value}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem
            rules={generatePropsForRules()}
            name={inputName}
            onFocus={() => onFocus(name)}
            style={{ width: "60%" }}
          >
            <Input
              style={{ width: "100%" }}
              placeholder={inputPlaceholder}
              defaultValue={inputDefaultValue}
              type={inputType}
              {...extraProps}
            />
          </FormItem>
        </InputGroup>
      )}
    </>
  );
};

export default FormGroupSelectionInput;

FormGroupSelectionInput.propTypes = {
  disabled: PropTypes.bool,
  extraProps: PropTypes.object,
  onFocus: PropTypes.func,
  selections: PropTypes.array,
};

FormGroupSelectionInput.defaultProps = {
  disabled: false,
  extraProps: {},
  onFocus: () => {},
  selections: [],
};
